import React from 'react';
// @ts-ignore
import styles from './WorkplaceWorkersToolbar.module.scss';
import Text from '../../../../../Components/Base/Text/Text';
import { View } from '../../../../../Enums/View.enum';
import { joinClasses } from '../../../../../Utils/className.util';
import Button from '../../../../../Components/Button/Button';
import { Theme } from '../../../../../Enums/Theme.enum';
import { useAppContext } from '../../../../../Services/AppContext';
import NetteApiClient from '../../../../../Services/NetteApiClient';

interface Props {
	itemsCount: number;
	onViewChange: (newState: View) => void;
	activeView: View;
	reloadData: () => void;
}

const WorkplaceWorkersToolbar: React.FC<Props> = ({
	itemsCount,
	activeView,
	onViewChange,
}) => {
	// @ts-ignore
	const { openAddNewWorker } = useAppContext();
	const handleAddNewWorker = () => {
		if (openAddNewWorker) {
			NetteApiClient.get(openAddNewWorker);
		}
	};

	return (
		<div className={styles.wrapper}>
			<div className={styles.leftSide}>
				<div className={styles.count}>
					<Text tx='base.numberOfRecords' firstUpper inline />: {itemsCount}
				</div>
			</div>
			<div className={styles.rightSide}>
				<Text
					tx='component.workplaceAndWorkers.text6'
					className={styles.infoText}
				/>
				<Button
					theme={Theme.GREEN}
					title='component.workplaceAndWorkers.registerANewEmployee'
					onClick={handleAddNewWorker}
				/>
				<div className={styles.viewToggle}>
					<div
						className={joinClasses([
							styles.toggleGrid,
							activeView === View.GRID ? styles.active : undefined,
						])}
						onClick={() => onViewChange(View.GRID)}
					/>
					<div
						className={joinClasses([
							styles.toggleList,
							activeView === View.LIST ? styles.active : undefined,
						])}
						onClick={() => onViewChange(View.LIST)}
					/>
				</div>
			</div>
		</div>
	);
};

export default WorkplaceWorkersToolbar;
